module.exports = __webpack_public_path__ + "img/logo.4b964506.png";